import { Queue } from '@cian/event-queue';

import { TEvents } from 'shared/types/events';

export const getEventQueue = (): Queue<TEvents> => {
  if (typeof window !== 'undefined') {
    return window.eventQueue || (window.eventQueue = new Queue<TEvents>());
  }

  return new Queue<TEvents>();
};
